import React from 'react'
import { match } from 'ts-pattern'

import { useDocumentCardContext } from '@frame/ui-components/document-card/context'

import { FileUploadState, TrackedFile } from '@documents/types'
import { DocumentCardDataAttribute } from '@frame/types'

import { Complete } from './states/complete'
import { Failed } from './states/failed'
import { Processing } from './states/processing'
import { getFileName } from './utils'

export type DocumentCardProps = Omit<TrackedFile, 'state' | 'classificationResults'> & {
  isLoading: boolean
  fileId?: string
  onDelete?: () => void
  onRetry?: () => void
}

export function DocumentCard({
  file,
  tempId,
  fileId,
  isLoading,
  onDelete,
  onRetry,
  isRetryable,
  error,
}: DocumentCardProps) {
  const fileName = getFileName(file)
  const { fileUploadState } = useDocumentCardContext()

  return (
    <div
      data-cy={DocumentCardDataAttribute.CARD}
      data-state={fileUploadState}
      className="flex flex-col gap-3 rounded-md border border-moss-300 bg-white p-4"
    >
      {match(fileUploadState)
        .with(FileUploadState.PROCESSING, () => <Processing isLoading={isLoading} fileName={fileName} />)
        .with(FileUploadState.COMPLETED, () => (
          <Complete fileName={fileName} tempId={tempId} fileId={fileId} onDelete={onDelete} />
        ))
        .with(FileUploadState.FAILED, () => (
          <Failed
            fileName={fileName}
            fileId={fileId}
            tempId={tempId}
            onRetry={onRetry}
            onDelete={onDelete}
            isRetryable={isRetryable}
            error={error}
          />
        ))
        .exhaustive()}
    </div>
  )
}
